"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = require("prop-types");
var _constant = require("@airasia/phoenix-components/components/Theme/constant");
var _constant2 = require("../constant");
var _constant3 = require("./constant");
var currencyObject = {
  shortform: _propTypes.string,
  shortSymbol: _propTypes.string,
  longform: _propTypes.string,
  icon: _propTypes.string
};
var localeObject = {
  shortform: _propTypes.string,
  longform: _propTypes.string,
  default: _propTypes.string,
  icon: _propTypes.string
};
var _default = {
  PropTypes: {
    defaultCurrency: _propTypes.string,
    defaultLocale: _propTypes.string,
    currencyList: (0, _propTypes.arrayOf)((0, _propTypes.shape)(currencyObject)),
    localeList: (0, _propTypes.arrayOf)((0, _propTypes.shape)(localeObject)),
    recommendedCurrencyList: (0, _propTypes.arrayOf)((0, _propTypes.shape)(currencyObject)),
    recommendedLocaleList: (0, _propTypes.arrayOf)((0, _propTypes.shape)(localeObject)),
    labelConfig: (0, _propTypes.shape)({
      popularLocale: _propTypes.string,
      otherLocale: _propTypes.string,
      locale: _propTypes.string,
      popularCurrency: _propTypes.string,
      otherCurrency: _propTypes.string,
      currency: _propTypes.string
    }),
    onLocaleChange: _propTypes.func,
    onCurrencyChange: _propTypes.func,
    icon: _propTypes.string,
    dropdownPosition: (0, _propTypes.oneOf)(Object.values(_constant3.DROPDOWN_POSITIONS)),
    showCurrency: _propTypes.bool,
    showLocale: _propTypes.bool,
    device: (0, _propTypes.oneOf)(Object.values(_constant2.DEVICE_TYPE)),
    dropdownConfig: _propTypes.object,
    modalConfig: _propTypes.object,
    sectionConfig: _propTypes.object,
    theme: _propTypes.string,
    accessible: _propTypes.bool,
    customProperties: _propTypes.object,
    fireGtm: _propTypes.func,
    gtmLocaleEventData: _propTypes.string,
    gtmCurrencyEventData: _propTypes.string
  },
  DefaultProps: {
    defaultCurrency: _constant3.LOCALE_CURRENCY_DEFAULTS.CURRENCY,
    defaultLocale: _constant3.LOCALE_CURRENCY_DEFAULTS.LOCALE,
    currencyList: _constant3.CURRENCY_LIST,
    localeList: _constant3.LOCALE_LIST,
    icon: _constant3.LOCALE_CURRENCY_DEFAULTS.ICONS.HEADER,
    labelConfig: {
      popularLocale: _constant3.LOCALE_CURRENCY_DEFAULTS.LABEL_CONFIG.POP_LANG,
      otherLocale: _constant3.LOCALE_CURRENCY_DEFAULTS.LABEL_CONFIG.OTHER_LANG,
      locale: _constant3.LOCALE_CURRENCY_DEFAULTS.LABEL_CONFIG.LANG,
      popularCurrency: _constant3.LOCALE_CURRENCY_DEFAULTS.LABEL_CONFIG.POP_CURR,
      otherCurrency: _constant3.LOCALE_CURRENCY_DEFAULTS.LABEL_CONFIG.OTHER_CURR,
      currency: _constant3.LOCALE_CURRENCY_DEFAULTS.LABEL_CONFIG.CURR
    },
    dropdownPosition: _constant3.LOCALE_CURRENCY_DEFAULTS.POSITION,
    showCurrency: true,
    showLocale: true,
    device: _constant2.DEVICE_TYPE.DESKTOP,
    theme: _constant.DEFAULT_THEME,
    accessible: true
  }
};
exports.default = _default;